import { render, staticRenderFns } from "./edit-materials.vue?vue&type=template&id=6e6a5a81"
import script from "./edit-materials.vue?vue&type=script&lang=js"
export * from "./edit-materials.vue?vue&type=script&lang=js"
import style0 from "./edit-materials.vue?vue&type=style&index=0&id=6e6a5a81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports